import { UserContext } from "App/contexts/AuthenticatedUserContext";
import { CallBar } from "Pages/agentDesktop/Pages/AgentDesktopTasks/Components/AgentTaskInterface/CallBar/CallBar";
import { userHasRoles } from "Services/AuthService";
import { UserRole } from "Types/Auth";

import { useAppSetupHooks } from "../Shared/Hooks/useAppSetupHooks";
import { useRegalAuthContext } from "./RegalAuthContext";

export default function UserProvider({ children }: React.PropsWithChildren<unknown>): JSX.Element {
    const { brand, refetch } = useAppSetupHooks();
    const auth = useRegalAuthContext();
    const providerValue = {
        user: auth.user,
        isAdmin: userHasRoles(auth.user, [UserRole.ADMIN, UserRole.SUPERVISOR]),
        brand,
        reloadBrand: refetch,
    };

    return (
        <UserContext.Provider value={providerValue}>
            {children}
            <CallBar />
        </UserContext.Provider>
    );
}
